// extracted by mini-css-extract-plugin
export default {"textwidth":"HomePage3_textwidth__7N+Ba","numberBox":"HomePage3_numberBox__AMauG"};